import { render, staticRenderFns } from "./ModalTextArea.vue?vue&type=template&id=85fdf66e&scoped=true&"
import script from "./ModalTextArea.vue?vue&type=script&lang=js&"
export * from "./ModalTextArea.vue?vue&type=script&lang=js&"
import style0 from "./ModalTextArea.vue?vue&type=style&index=0&id=85fdf66e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fdf66e",
  null
  
)

export default component.exports